module.exports = __webpack_public_path__ + "fonts/DINPro-Bold.f5399069.ttf";